import { gql } from "@apollo/client";

export const GET_PROVIDERS = gql`
  query GetProviders(
    $search: String,
    $type: String,
    $ownership: String,
    $country: String,
    $city: String,
    $state: String,
    $category: String,
    $page: Int,
    $limit: Int
  ) {
    getProviders(
      search: $search,
      type: $type,
      ownership: $ownership,
      country: $country,
      city: $city,
      state: $state,
      category: $category,
      page: $page,
      limit: $limit
    ) {
      providers {
        id
        name
        type
        ownership
        city
        country
        email
        website
        logoUrl
        description
      }
      meta {
        totalItems
        itemCount
        itemsPerPage
        totalPages
        currentPage
      }
    }
  }
`;

export const GET_PROVIDER_LOGO = gql`
  query GetProviderLogo($filename: String!) {
    getLogoProvider(filename: $filename) {
      base64Data
      mimetype
    }
  }
`;

export const GET_PROVIDER_IMAGE = gql`
  query GetProviderImage($providerId: Int!, $filename: String!) {
    getProviderImage(providerId: $providerId, filename: $filename) {
      base64Data
      mimetype
    }
  }
`;

export const GET_PROVIDER_BY_ID = gql`
  query GetProviderById($id: Int!) {
    provider(id: $id) {
      id
      name
      city
      country
      state
      postalCode
      address
      description
      yearFounded
      type
      website
      email
      phone
      linkedin
      x
      ownership
      category
      languages
      degreeTypes
      logoUrl
      imageUrls
    }
  }
`;

export const GET_MY_PROVIDERS = gql`
  query GetMyProviders(
    $search: String,
    $type: String,
    $ownership: String,
    $country: String,
    $city: String,
    $state: String,
    $category: String,
    $page: Int,
    $limit: Int
  ) {
    getMyProviders(
      search: $search,
      type: $type,
      ownership: $ownership,
      country: $country,
      city: $city,
      state: $state,
      category: $category,
      page: $page,
      limit: $limit
    ) {
      providers {
        id
        name
        type
        ownership
        city
        country
        email
        website
        logoUrl
        imageUrls
        description
        createdAt
        createdBy {
          id
          username
          email
        }
      }
      meta {
        totalItems
        itemCount
        itemsPerPage
        totalPages
        currentPage
      }
    }
  }
`;